import { render, staticRenderFns } from "./createoldstufflist.vue?vue&type=template&id=ac83a07a"
import script from "./createoldstufflist.vue?vue&type=script&lang=js"
export * from "./createoldstufflist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports